import { createApp } from 'vue';
import WebmToMp3Converter from '@/Components/WebmToMp3Converter.vue';
import '@styles/app.css';

createApp(WebmToMp3Converter).mount('#webm-to-mp3-converter');
